import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Link } from 'react-router-dom';
import { Mail, Loader2, ArrowLeft, CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [email, setEmail] = useState('');
  const [resetToken, setResetToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Please enter your email'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      if (res.data.reset_token) setResetToken(res.data.reset_token);
      toast.success('Reset instructions sent');
    } catch { toast.error('Failed to send reset email'); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-page" data-testid="forgot-password-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">D</div>
          <h1>DepinaCRM</h1>
        </div>
        {!sent ? (
          <>
            <h2>Reset your password</h2>
            <p className="auth-subtitle">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-field">
                <label>Email</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com" data-testid="forgot-email" />
              </div>
              <button type="submit" className="auth-submit" disabled={loading} data-testid="forgot-submit">
                {loading ? <Loader2 className="animate-spin" size={18} /> : <Mail size={18} />}
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          </>
        ) : (
          <div className="auth-success">
            <CheckCircle size={48} className="auth-success-icon" />
            <h2>Check your email</h2>
            <p>If an account exists for {email}, a reset link has been sent.</p>
            {resetToken && (
              <Link to={`/reset-password?token=${resetToken}`} className="auth-submit" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 16 }}>
                Reset Password Now
              </Link>
            )}
          </div>
        )}
        <Link to="/login" className="auth-back"><ArrowLeft size={16} /> Back to sign in</Link>
      </div>
    </div>
  );
}
